export default function isAbsolutePath(url) {
  const urlRegex = new RegExp("^(?:[a-z+]+:)?//", "i");
  return urlRegex.test(url);
}
